import * as runtimeDom from '@vue/runtime-dom';
import { initCustomFormatter, registerRuntimeCompiler, warn } from '@vue/runtime-dom';
export * from '@vue/runtime-dom';
import { compile } from '@vue/compiler-dom';
import { isString, NOOP, extend, generateCodeFrame } from '@vue/shared';

function initDev() {
  {
    initCustomFormatter();
  }
}

if (!!(process.env.NODE_ENV !== "production")) {
  initDev();
}

var compileCache = /* @__PURE__ */Object.create(null);

function compileToFunction(template, options) {
  if (!isString(template)) {
    if (template.nodeType) {
      template = template.innerHTML;
    } else {
      !!(process.env.NODE_ENV !== "production") && warn("invalid template option: ", template);
      return NOOP;
    }
  }

  var key = template;
  var cached = compileCache[key];

  if (cached) {
    return cached;
  }

  if (template[0] === "#") {
    var el = document.querySelector(template);

    if (!!(process.env.NODE_ENV !== "production") && !el) {
      warn("Template element not found or is empty: ".concat(template));
    }

    template = el ? el.innerHTML : "";
  }

  var opts = extend({
    hoistStatic: true,
    onError: !!(process.env.NODE_ENV !== "production") ? onError : void 0,
    onWarn: !!(process.env.NODE_ENV !== "production") ? function (e) {
      return onError(e, true);
    } : NOOP
  }, options);

  if (!opts.isCustomElement && typeof customElements !== "undefined") {
    opts.isCustomElement = function (tag) {
      return !!customElements.get(tag);
    };
  }

  var _compile = compile(template, opts),
      code = _compile.code;

  function onError(err) {
    var asWarning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var message = asWarning ? err.message : "Template compilation error: ".concat(err.message);
    var codeFrame = err.loc && generateCodeFrame(template, err.loc.start.offset, err.loc.end.offset);
    warn(codeFrame ? "".concat(message, "\n").concat(codeFrame) : message);
  }

  var render = new Function("Vue", code)(runtimeDom);
  render._rc = true;
  return compileCache[key] = render;
}

registerRuntimeCompiler(compileToFunction);
export { compileToFunction as compile };